import styled from 'styled-components'
import Flex from '../../../Layout/Flex/Flex'
import { SpinnerProps } from './types'

export const SpinnerWrapper = styled(Flex)<SpinnerProps>`
  width: ${props => props.buttonMode ? 'auto' : props.removeFullscreen ? '100%' : '100vw'};
  height: ${props => props.buttonMode ? 'auto' : props.removeFullscreen ? '100%' : '100vh'};
  min-height: ${props => props.minHeight
    ? `calc(100vh - ${props.theme.size.headerHeight || 0} - ${props.theme.size.footerHeight || 0})`
    : 'auto'
};
`
